<template>
    <div class="row">
        <div class="col-12">
            <h2>{{ adoptee.name }}</h2>
        </div>
        <div class="col-md-8 p-1">
            <div
                class="card"
                style="width: 100%; height: 100%; margin-bottom: 0;"
            >
                <img
                    class="card-img-top"
                    :src="'/storage/' + adoptee.image"
                    alt="Card image cap"
                    style="max-height: 300px; object-fit: cover;"
                />
                <div class="card-body">
                    <p class="title">Wallpaper Pack</p>
                    <a :href="`/user/downloads/${adoptee.slug}/wallpapers`"
                        ><strong>Download</strong></a
                    >
                </div>
            </div>
        </div>
        <div class="col-md-4 p-1">
            <div
                class="card"
                style="width: 100%; height: 100%; margin-bottom: 0;"
            >
                <img
                    class="card-img-top"
                    :src="
                        '/storage/' +
                            (adoptee.cert_image
                                ? adoptee.cert_image
                                : 'imgs/downloadables/E-certificate.jpg')
                    "
                    alt="Card image cap"
                />
                <div class="card-body">
                    <p class="title">Adoption e-Certificate</p>
                    <p class="card-text">
                        To salute the spirit of Wildlife Hero in you!
                    </p>
                    <a href="#" @click="downloadECertificate()"
                        ><strong>Download</strong></a
                    >
                </div>
            </div>
        </div>
        <div v-if="adoptee.has_webinars" class="col-md-4 p-1">
            <div
                class="card"
                style="width: 100%; height: 100%; margin-bottom: 0;"
            >
                <img
                    class="card-img-top"
                    :src="
                        '/storage/' +
                            (adoptee.cert_image
                                ? adoptee.cert_image
                                : 'imgs/downloadables/E-certificate.jpg')
                    "
                    alt="Card image cap"
                />
                <div class="card-body">
                    <p class="title">Webinars</p>
                    <p class="card-text"></p>
                    <a :href="`/user/downloads/${adoptee.slug}/webinars`"
                        ><strong>Watch Now</strong></a
                    >
                </div>
            </div>
        </div>
        <div
            class="col-md-4 p-1"
            v-for="(adoptee, index) in this.adoptee.downloadables"
            :key="adoptee.title + index"
        >
            <div
                class="card"
                style="width: 100%; height: 100%; margin-bottom: 0;"
            >
                <img
                    class="card-img-top"
                    :src="
                        adoptee.image
                            ? '/storage/' + adoptee.image
                            : '/storage/imgs/downloadables/FB-Frame.jpg'
                    "
                    alt="Card image cap"
                />
                <div class="card-body">
                    <p class="title">{{ adoptee.title }}</p>
                    <p class="card-text">
                        {{ adoptee["sub-line"] }}
                    </p>
                    <a :href="adoptee.btn_link" target="_blank"
                        ><strong>{{ adoptee.btn_text }}</strong></a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["adoptee"],
    data() {
        return {};
    },
    created() {},
    methods: {
        downloadECertificate() {
            fetch(`/user/downloads/${this.adoptee.slug}/checkIfDonor`)
                .then(res => res.json())
                .then(res => {
                    if (res.message) {
                        swal({
                            title: "Sorry!",
                            text: res.message,
                            icon: "warning"
                        });
                    } else {
                        const link = document.createElement("a");
                        link.href = res.url;
                        link.click();
                    }
                })
                .catch(err => console.log(err));
        },
        downloadInstagram() {
            Swal.fire(
                "Coming soon!",
                "No available download link for instagram.",
                "warning"
            );
        }
    }
};
</script>

<style scoped>
#title {
    background-color: black;
    border: none;
    color: #f58220;
    width: fit-content;
    padding: 0 15px;
    font-family: "WWF";
    font-size: 2.5em;
    margin-left: 15px;
}

.card {
    border: none !important;
    box-shadow: black;
    background-color: #f9f9f9 !important;
    margin-bottom: 10px !important;
}

.card .card-body {
    padding: 25px;
}

.card .card-text {
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    color: black;
    text-decoration: none;
}
.card .title {
    font-size: 1.2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
    color: black;
}
#welcome-pack-container {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
#welcome-pack {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 3px;
    /* min-width: 100%; */
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
#welcome-pack div {
    margin: 120px 0px;
    padding: 0px 70px;
}
#welcome-pack h2 {
    font-weight: bolder;
}
</style>
